var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { width: "1300" },
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c("EditarHorarioGeneral"),
      _vm._v(" "),
      _c("AsignarHorarioHistorico"),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            { staticClass: "headline" },
            [
              _c("v-icon", [_vm._v("event_note")]),
              _vm._v("\n      Historico de horarios \n      "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { icon: "" },
                  on: {
                    click: function($event) {
                      return _vm.close()
                    }
                  }
                },
                [_c("v-icon", [_vm._v("clear")])],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-text",
            { staticClass: "py-0" },
            [
              _c(
                "v-tooltip",
                { attrs: { bottom: "" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { slot: "activator", color: "primary", dark: "" },
                      nativeOn: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.crearHorarioHistorico()
                        }
                      },
                      slot: "activator"
                    },
                    [
                      _c("v-icon", { attrs: { dark: "" } }, [_vm._v("add")]),
                      _vm._v(" Crear horario historico")
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("span", [_vm._v("Crear horario historico")])
                ],
                1
              ),
              _vm._v(" "),
              _c("v-data-table", {
                staticClass: "elevation-1",
                attrs: {
                  headers: _vm.headers,
                  items: _vm.lista_horarios,
                  "no-data-text": _vm.loading
                    ? "Cargando..."
                    : "No se tiene registros",
                  "disable-initial-sort": true,
                  "no-results-text": "No se encontraron coincidencias",
                  loading: _vm.loading,
                  "rows-per-page-items": [10, 25, { text: "Todos", value: -1 }],
                  pagination: _vm.pagination,
                  "rows-per-page-text": "Filas por pagina"
                },
                on: {
                  "update:pagination": function($event) {
                    _vm.pagination = $event
                  }
                },
                scopedSlots: _vm._u([
                  {
                    key: "headers",
                    fn: function(props) {
                      return [
                        _c(
                          "tr",
                          _vm._l(props.headers, function(header) {
                            return _c(
                              "th",
                              {
                                key: header.text,
                                class: [
                                  "column sortable",
                                  _vm.pagination.descending ? "desc" : "asc",
                                  header.value === _vm.pagination.sortBy
                                    ? "active"
                                    : ""
                                ],
                                attrs: { id: "header-comprmido" },
                                on: {
                                  click: function($event) {
                                    return _vm.changeSort(header.value)
                                  }
                                }
                              },
                              [
                                _c(
                                  "v-icon",
                                  { attrs: { small: "", color: "blue" } },
                                  [_vm._v("arrow_upward")]
                                ),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(header.text) +
                                    "\n            "
                                )
                              ],
                              1
                            )
                          }),
                          0
                        )
                      ]
                    }
                  },
                  {
                    key: "items",
                    fn: function(props) {
                      return [
                        _c(
                          "tr",
                          {
                            style:
                              props.item.coincidencia == 0
                                ? ""
                                : "background:rgb(250, 187, 203,0.5)"
                          },
                          [
                            _c(
                              "td",
                              { staticClass: "text-xs-center py-0 px-1" },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(props.item.descripcion_horario) +
                                    "\n            "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              { staticClass: "text-xs-center py-0 px-1" },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(props.item.descripcion) +
                                    "\n            "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              { staticClass: "text-xs-center py-0 px-1" },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(props.item.hora_inicio) +
                                    "\n            "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              { staticClass: "text-xs-center py-0 px-1" },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(props.item.hora_fin) +
                                    "\n            "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              { staticClass: "text-xs-center py-0 px-1" },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(props.item.hora_inicio2) +
                                    "\n            "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              { staticClass: "text-xs-center py-0 px-1" },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(props.item.hora_fin2) +
                                    "\n            "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              { staticClass: "text-xs-center py-0 px-1" },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm
                                        .$moment(props.item.fecha_desde)
                                        .format("DD/MM/YYYY")
                                    ) +
                                    "\n              "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              { staticClass: "text-xs-center py-0 px-1" },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      props.item.fecha_hasta
                                        ? _vm
                                            .$moment(props.item.fecha_hasta)
                                            .format("DD/MM/YYYY")
                                        : ""
                                    ) +
                                    "\n              "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            props.item.id_estado == 1
                              ? _c(
                                  "td",
                                  {
                                    staticClass: "text-xs-center py-0 px-1",
                                    staticStyle: { background: "#7EDDD3" }
                                  },
                                  [
                                    _vm._v(
                                      "\n              VIGENTE\n            "
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            props.item.id_estado == 2
                              ? _c(
                                  "td",
                                  { staticClass: "text-xs-center py-0 px-1" },
                                  [
                                    _vm._v(
                                      "\n              INACTIVO\n            "
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "td",
                              { staticClass: "text-xs-center py-0 px-1" },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      color: "#007DBA",
                                      icon: "",
                                      title: "Editar",
                                      outline: ""
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.EditarHorarioGeneral(
                                          props.item
                                        )
                                      }
                                    }
                                  },
                                  [_c("v-icon", [_vm._v("edit")])],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      color: "error",
                                      icon: "",
                                      title: "Eliminar",
                                      outline: ""
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.eliminarHorario(props.item)
                                      }
                                    }
                                  },
                                  [_c("v-icon", [_vm._v("delete")])],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  nativeOn: {
                    click: function($event) {
                      return _vm.close()
                    }
                  }
                },
                [
                  _c("v-icon", [_vm._v("cancel")]),
                  _vm._v(" " + _vm._s(_vm.$t("common.cancel")) + "\n      ")
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a12c5f92", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a12c5f92","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/asignacion_horario/dialogs/VerHorarioContinuoDiscontinuo.vue
// module id = null
// module chunks = 